var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNagad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8957",
    fill: "none",
    stroke: "#707070",
    d: "M0 0H32V32H0z",
    transform: "translate(468 421)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#ec1c24}.cls-4{fill:#f6921e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58098",
    clipPath: "url(#clip-path)",
    transform: "translate(-468 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nagad_Logo_for_web__128x53",
    transform: "translate(469.92 424.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60999",
    transform: "translate(2 0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154244",
    d: "M23.95 16.226a6.041 6.041 0 0 1-.045.9 10.907 10.907 0 0 1-.947 3.651 12.141 12.141 0 0 1-.721 1.307A10.968 10.968 0 1 1 8.085 6.4a10.485 10.485 0 0 0-.766 1.172c0 .045-.045.045-.045.09-.135.135-.27.225-.406.361a5.142 5.142 0 0 0-.5.5c-.045.045-.09.09-.09.135-.045.045-.09.09-.09.135l-.18.18a2.477 2.477 0 0 0-.316.406 10.359 10.359 0 0 0-1.127 1.938c-.045.09-.045.135-.09.225s-.045.18-.09.225c-.135.09-.135.135-.135.18l-.135.406c-.045.09-.045.18-.09.27 0 .045-.045.09-.045.135 0 .09-.045.18-.045.27a3.869 3.869 0 0 0-.135.766.406.406 0 0 1-.045.225v1.127a9.481 9.481 0 0 0 3.516 7.392 9.6 9.6 0 0 0 11.674.361 8.963 8.963 0 0 0 2.794-3.155c.09-.18.18-.316.27-.5a9.731 9.731 0 0 0 .9-3.786v-.316a6.657 6.657 0 0 0-.045-.947l.045.045a1.765 1.765 0 0 0 .451.361 3.2 3.2 0 0 1 .451-.631A12.15 12.15 0 0 1 24 15.234a3.743 3.743 0 0 0-.045.992",
    className: "cls-3",
    transform: "translate(-2 -3.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154245",
    d: "M24.956 16.737v.316a9.486 9.486 0 0 1-.9 3.786c-.09.18-.18.316-.27.5a9.425 9.425 0 0 1-2.794 3.155 9.6 9.6 0 0 1-11.674-.361A9.481 9.481 0 0 1 5.8 16.737V15.61a.406.406 0 0 1 .045-.225c.045-.27.135-.541.18-.811 0-.09.045-.18.045-.27 0-.045.045-.09.045-.135.045-.09.045-.18.09-.27.045-.135.09-.225.135-.361 0-.045.045-.09.045-.135.045-.09.045-.18.09-.225.045-.09.045-.135.09-.225a9.1 9.1 0 0 1 1.127-1.938c.09-.135.225-.27.316-.406.045-.045.09-.135.18-.18.045-.045.045-.09.09-.135s.09-.09.09-.135a5.142 5.142 0 0 1 .5-.5 2.916 2.916 0 0 1 .403-.359.157.157 0 0 1-.045.09c0 .045-.045.09-.045.135A11.41 11.41 0 0 0 8.144 13.4a9.8 9.8 0 0 0-.044 1.173c0 5 2.93 9.06 6.581 9.06h.406a5.724 5.724 0 0 0 1.532-.225 5.8 5.8 0 0 0 4.281-5.589v-.18a5.658 5.658 0 0 0-1.8-4.011 8.356 8.356 0 0 1 2.163.316 10.054 10.054 0 0 1 3.606 1.8l.045.045c0 .316.045.631.045.947",
    className: "cls-4",
    transform: "translate(-4.087 -5.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154246",
    d: "M24.9 16.627v.316a9.657 9.657 0 0 1-.9 3.831c-.09.18-.18.316-.27.5a10.037 10.037 0 0 1-2.794 3.2A9.618 9.618 0 0 1 9.261 9.19l.09-.09c0 .045-.045.045-.045.09a.157.157 0 0 1-.045.09 9.56 9.56 0 0 0 .09 14.739 9.111 9.111 0 0 0 5.95 2.163 9.607 9.607 0 0 0 5.589-1.8 9.879 9.879 0 0 0 2.794-3.155c.09-.18.18-.316.27-.5a8.552 8.552 0 0 0 .9-3.786v-.316a5.747 5.747 0 0 0-.045-.9v-.045l.045.045.045.045v.856",
    className: "cls-4",
    transform: "translate(-4.032 -5.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154247",
    d: "M28.493 6.281S20.651 4.794 17 11.6c0 0 .631-4.688 6.22-6.851l-1.127-2.073a7.94 7.94 0 0 1 6.175-1.487z",
    className: "cls-3",
    transform: "translate(-10.239 -0.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154248",
    d: "M21 14.008s3.11-4.1 10.276-3.02l-.09-2.388a8.737 8.737 0 0 1 5.414 1.982l-2.98 4.508a8.526 8.526 0 0 0-6.265-2.434A13.562 13.562 0 0 0 21 14.008",
    className: "cls-4",
    transform: "translate(-12.436 -4.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154249",
    d: "M23.928 22.691s-.676.135-.631-.18c0-.135.09-.18.135-.135 0-.045-.135-.225.18-.316a4.157 4.157 0 0 0 .225-.361c.045-.09.09-.225.361-.135a1.028 1.028 0 0 1 .586.406.654.654 0 0 1 .27.045l-.09.09s.09.045-.18.045a.1.1 0 0 0 .09.09c.045.045 0 .045 0 .09 0 0 .045.135-.09.09s-.135-.09-.18-.09-.135 0-.135.045.135.135 0 .135c-.045.045.045.09 0 .09a2.366 2.366 0 0 1-.5.316c-.135 0-.18-.045-.18-.09s.09-.09.18-.09c-.045 0 0-.045-.045-.045",
    className: "cls-3",
    transform: "translate(-13.697 -12.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154250",
    d: "M24.383 24.975c-.045 0-.27-.135-.135-.18a4.952 4.952 0 0 1 .631-.406.1.1 0 0 1 .09.18 4.762 4.762 0 0 1-.586.406",
    className: "cls-3",
    transform: "translate(-14.197 -13.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154251",
    d: "M26.1 24.464c0-.09.09-.361.09-.406s.225-.09.18.18c-.09.225-.27.316-.27.225",
    className: "cls-3",
    transform: "translate(-15.238 -13.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154252",
    d: "M26.306 23.776a13.5 13.5 0 0 1 1.352 0 1.641 1.641 0 0 1 .406 1.307c-.09.586-.27.721-1.082.811a2.357 2.357 0 0 0-.135-.811c-.09-.135-.361-.451-.451-.451 0 .135-.045.541-.045.541s-.406.045-.451-.045V24.5a3.4 3.4 0 0 0 .406-.406c.045.045.09.225.5.18 0 .045-.5.09-.5-.5",
    className: "cls-3",
    transform: "translate(-15.128 -13.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154253",
    d: "M25.064 25.1s-.406.316-.5.406c-.045.09-.09.451.406.451a3.6 3.6 0 0 0 .09-.856",
    className: "cls-3",
    transform: "translate(-14.382 -13.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154254",
    d: "M23.325 25.8c-.135 0-.225-.045-.225-.135a.271.271 0 0 1 .316-.18c.09.045.316.09.316.5a.918.918 0 0 0 .631.27c.316 0 .5 0 .5.09v.586A2.8 2.8 0 0 1 23.6 26.3a.409.409 0 0 1-.135-.316c0-.135-.09-.18-.135-.18",
    className: "cls-3",
    transform: "translate(-13.59 -14.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154255",
    d: "M22.537 26.3c-.135 0-.586.361-.27.5l.18-.18s-.09.225.09.27.09-.09.18-.09c.045.09.045.135.135.135s.09-.27 0-.406a.3.3 0 0 0-.316-.225",
    className: "cls-3",
    transform: "translate(-13.071 -14.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154256",
    d: "M27.2 26.4v1.172s.361-.135.406-.225c0-.18-.09-.947-.406-.947",
    className: "cls-3",
    transform: "translate(-15.842 -14.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154257",
    d: "M25.1 28.1a3.965 3.965 0 0 0 .721.406c-.045.045-.225.316-.316.27a1.75 1.75 0 0 1-.405-.676",
    className: "cls-3",
    transform: "translate(-14.688 -15.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154258",
    d: "M20.831 29.325h-.586L20.2 29.1h.631z",
    className: "cls-3",
    transform: "translate(-11.997 -16.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154259",
    d: "M29.806 29.116h2.163V28.8H29.4z",
    className: "cls-3",
    transform: "translate(-17.05 -15.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154260",
    d: "M27.416 28.793c.045-.045.361.18.27.225s-.9.361-.947.361c-.09-.045-.045-.225.045-.27a4.055 4.055 0 0 0 .631-.316",
    className: "cls-3",
    transform: "translate(-15.562 -15.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154261",
    d: "M25.79 29.667c-.09-.045-.586.451-.361.5a4.383 4.383 0 0 1 .9.225.356.356 0 0 0 .225-.225c.09 0 .225.135.361.09a2.642 2.642 0 0 0 .766-.586 1.523 1.523 0 0 0-.541-.27c-.09-.045-.9.451-1.352.27",
    className: "cls-3",
    transform: "translate(-14.837 -16.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154262",
    d: "M23.887 30.961c.045 0 .721.225.856.225.18-.045.18-.18.27-.18s.135.09.27 0a6.086 6.086 0 0 0 .5-.406c0 .09 0 .361-.586.631a12.3 12.3 0 0 0-2.028.856 2.028 2.028 0 0 0 .361-.09.513.513 0 0 1 .18.541c-.045.316-.27.811-.27.947v.856c0 .045.135.451-.045.406a.482.482 0 0 0-.361 0c-.09 0-.225.135-.316.09-.135 0-.316-.09-.316-.135s.135-.045.27-.09.18-.18.406-.27c0-.135-.09-1.262-.09-1.487s-.09-.721.045-.9c.09-.27.631-1.037.856-.992",
    className: "cls-3",
    transform: "translate(-13.205 -16.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154263",
    d: "M27.6 32.251c0 .09.406 1.082.586 1.082a10.63 10.63 0 0 1 2.163-.225c.09.135.27.361.27.5 0 0 .045.316 0 .361a.308.308 0 0 0 .225-.135 2.953 2.953 0 0 0 0-.631c0-.09.225-.5-.045-.451a12.666 12.666 0 0 1-1.307-.045c-.225-.045-.811-.18-.947-.09a1.037 1.037 0 0 0-.316.361c-.045 0-.09-.045 0-.225a2.919 2.919 0 0 0 .225-.947c-.135.045-.856.451-.856.451",
    className: "cls-3",
    transform: "translate(-16.061 -17.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154264",
    d: "M23.9 29.245a.342.342 0 0 0 .09.18l-1.307-.09s-.135-.09-.09-.135z",
    className: "cls-3",
    transform: "translate(-13.304 -16.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154265",
    d: "M22.08 28.825h1.307s-.09-.135-.135-.225h-1.217s-.135 0-.135.27c0 .045.09.135.18-.045",
    className: "cls-3",
    transform: "translate(-12.931 -15.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154266",
    d: "M17.413 28.994h.27s.09-.045 0-.135-.27-.18-.135-.361c-.135 0-.316-.045-.27.361h-.135s-.045-.225-.361-.225a4.614 4.614 0 0 0-1.082.316 8.665 8.665 0 0 0 1.082.225.475.475 0 0 0 .361-.225h.09a.761.761 0 0 0 .09.225v.27a.14.14 0 0 0-.09.18c0 .135.09.135.135.135s.045-.045.18-.045c.045-.045 0-.225-.09-.27v-.18s.09-.09.09-.135c-.045-.09-.135-.045-.135-.135",
    className: "cls-3",
    transform: "translate(-9.525 -15.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154267",
    d: "M21.712 30.862a.352.352 0 0 0 .135-.18v-.766c0-.18-.316-.316-.361-.316a.342.342 0 0 1-.18.09.248.248 0 0 1-.225-.09c-.27 0-.406.316-.406.361a3.846 3.846 0 0 0 0 .721.383.383 0 0 0 .135.225c-.045.18-.316 1.217.045 1.352v.18h.9v-.18c.27-.225.045-1.127-.045-1.4m-1.037-.947a.4.4 0 0 1 .316-.27.331.331 0 0 0 .27.09c.09 0 .18-.09.225-.09.09.045.27.135.27.27v.766c0 .045-.045.09-.09.135h-.18v-.361H20.9v.316h-.135a.234.234 0 0 1-.09-.18v-.676m.631 2.118h-.18a.09.09 0 0 1 0-.18h.18a.09.09 0 0 1 0 .18m.361.09l-.451-.5-.406.5c-.27-.09-.09-.9 0-1.262h.856c.09.361.225 1.127 0 1.262",
    className: "cls-3",
    transform: "translate(-12.247 -16.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154268",
    d: "M21.715 32.925a.159.159 0 0 0-.045-.225h-.541c-.18 0-.135.225-.135.225l.316.27a.716.716 0 0 0 .406-.27",
    className: "cls-3",
    transform: "translate(-12.43 -18.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154269",
    d: "M22.1 33.625l.316.361s-.045-.451-.045-.586c-.045.045-.27.225-.27.225",
    className: "cls-3",
    transform: "translate(-13.04 -18.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154270",
    d: "M21.045 33.4c0 .135-.045.586-.045.586l.316-.361a1.716 1.716 0 0 0-.27-.225",
    className: "cls-3",
    transform: "translate(-12.436 -18.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154271",
    d: "M21.841 31.19h.045v-.045a.044.044 0 0 0-.045-.045h-.5a.044.044 0 0 0-.045.045v.045h.541z",
    className: "cls-3",
    transform: "translate(-12.601 -17.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154272",
    d: "M20.845 35.9H20.8v.045a.044.044 0 0 0 .045.045h.9a.044.044 0 0 0 .045-.045V35.9h-.947z",
    className: "cls-3",
    transform: "translate(-12.326 -19.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154273",
    d: "M13.274 13.2S9.713 5.4 18.006.4l1.984 3.651a9.122 9.122 0 0 0-2.79 1.713 12.143 12.143 0 0 0-3.926 7.436",
    className: "cls-4",
    transform: "translate(-7.775 -0.4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNagad);
export default __webpack_public_path__ + "static/media/nagad.e6f41acca779829e61e3f07d39aac866.svg";
export { ForwardRef as ReactComponent };